import { IWebsiteUserAppointment } from "./website-user-appointment.interface";
import WEBSITE_USER_APPOINTMENT_QUERY from "./website-user-appointment.query";
import { useLazyQuery } from "@apollo/client";

const useWebsiteUserAppointment = () => {
  const [getWebUserAppointment, { data, loading, error }] =
  useLazyQuery<IWebsiteUserAppointment>(WEBSITE_USER_APPOINTMENT_QUERY);

  const getUserAppointment = () => {
    getWebUserAppointment({
      fetchPolicy: "cache-and-network",
    });
  };

  return {
    webUserAppointment: data?.getWebUserAppointment,
    loading,
    error,
    getUserAppointment,
  };
};

export default useWebsiteUserAppointment;
